import React from 'react';
import { Link } from 'react-router-dom';
import './style.css'
import logo from '../../assets/logo.png'

const Header = () => {
  return (
    <div className="header">
      <div className="cabecera">
        <div className="cabeceraTop">
          

          <div className="cabecera-logo">
            <Link to="/">
              <img className="logo" src={logo} alt="Ir a la home" />
            </Link>
          </div>
          <a className="boton-ingresar" href="#ingresar">
          <a href="https://wa.me/+5491125531022?text=Hola%20me%20gustaría%20saber%20el%20precio%20de%20" class="whatsapp" target="_blank" rel="noopener noreferrer"> <i class="fa fa-whatsapp whatsapp-icon"></i></a>
          </a>
        </div>
      </div>
    </div>
  )
}
export default Header;
